
export const NUM_DEFAULT_TABS = 4;

export const customTabKey = (tab) => `custom-${tab.financial_group_type}`;

export const getCustomTabs = (accountStructure) => {
    const tabs = accountStructure?.custom?.flat() ?? [];
    return [...tabs].sort((a, b) => (a.tab_index ?? 0) - (b.tab_index ?? 0));
};

export const findCustomTabByKey = (accountStructure, key) =>
    getCustomTabs(accountStructure).find((t) => customTabKey(t) === key) ?? null;

export const isCustomTabKey = (key) => String(key ?? '').startsWith('custom-');